import React, { useContext } from 'react';
import { FieldTypes } from '@ubeya/shared/hooks/account/useFields';
import { validateFactory } from '@ubeya/shared-web/utils/employee';
import ConfigContext from '../../contexts/ConfigContext';
import DynamicField from './DynamicField';

const DynamicFieldComp = ({
  field,
  className,
  title,
  validate,
  overrideRequiredField,
  enableShowLinks,
  namePrefix = 'fields',
  showDeleteSuffix = true
}) => {
  const {
    id,
    name,
    fieldTypeId,
    options: fieldOptions,
    allowMultiple,
    isMultiline,
    metadata,
    hasExpiration,
    isReadOnly,
    isRequired
  } = field || {};
  const { t } = useContext(ConfigContext);

  const validationByOverrideRequiredField = (value) =>
    validateFactory({
      value,
      fieldTypeId,
      t,
      metadata,
      validate,
      hasExpiration,
      isRequired: overrideRequiredField && isRequired
    });

  const isClearable =
    [FieldTypes.FIELD_TYPE_OPTIONS, FieldTypes.FIELD_TYPE_ADDRESS].includes(fieldTypeId) && !allowMultiple;

  const fieldTitle = title || t(name);
  const displayTitle = showDeleteSuffix && field?.isDeleted ? `${fieldTitle} (${t('isDeleted')})` : fieldTitle;

  return (
    <DynamicField
      key={id}
      className={className}
      name={`${namePrefix}.field-${id}`}
      title={displayTitle}
      fieldTypeId={fieldTypeId}
      options={fieldOptions}
      allowMultiple={allowMultiple}
      isMultiline={isMultiline}
      hasExpiration={hasExpiration}
      validate={validationByOverrideRequiredField}
      required={overrideRequiredField && isRequired}
      readOnly={isReadOnly}
      isDisabled={isReadOnly}
      disabled={isReadOnly}
      metadata={metadata}
      enableShowLinks={enableShowLinks}
      clearable={isClearable}
    />
  );
};

export default DynamicFieldComp;
